<app-apportionment-entry [data]="e" *ngFor="let e of data"></app-apportionment-entry>
